import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';

@Pipe({
    name: 'contentNews',
    standalone: false
})
export class NewsPipe implements PipeTransform {

  constructor(private contentPipeService: ContentPipeService) {
  }

  transform(entry: any): Models.NewsEntry | Models.NewsEntry[] {
    if (!entry) {
      return null;
    }

    if (!entry.content) {
      return null;
    }

    const news: any = new Models.NewsEntry();

    const firstFile = this.contentPipeService.getMedia(entry);
    let description = entry.content.content || entry.content.description || entry.content.textContent;
    if (description === 'null') {
      description = null;
    }
    news.populateFromJSON({
      sourceId: entry._id,
      title: entry.title,
      description,
      timestamp: entry.content.timestamp || entry.content.date,
      url: entry.content.url || entry.content.bookingUrl,
      imageURL: (firstFile && firstFile.length) ? firstFile[0].URL : null,
      documents: this.contentPipeService.getDocuments(entry)
    });
    if (news.imageURL) {
      news.media = [{ URL: news.imageURL, type: 'image' }];
    }
    news.dateFormat = entry.content.noTime ? 'dd. LLLL' : 'eventDate';
    news.contentType = 'news';
    if (entry.content && entry.content.bookingText) {
      news['urlText'] = entry.content.bookingText;
    }
    if (entry.content?.contact?.length) {
      for (const contactVariant of entry.content.contact) {
        if (contactVariant.type === 'phone') {
          news['phone'] = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          news['fax'] = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          news['email'] = contactVariant.value;
        }
      }
    }
    if (entry.content && entry.content.location) {
      news['street'] = entry.content.location.address;
      news['city'] = entry.content.location.city;
      news['zip'] = entry.content.location.zip;
      if (entry.content.location.coordinates) {
        news['latitude'] = entry.content.location.coordinates.latitude;
        news['longitude'] = entry.content.location.coordinates.longitude;
      }
    }

    return news;
  }

}
